const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const DeleteCodes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CODES_DELETE_REQUEST":
      return { loading: true, error: false, data: [] };
    case "CODES_DELETE_ERROR":
      return { loading: false, error: true, data: [] };
    case "CODES_DELETE_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "CODES_DELETE_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default DeleteCodes;
